module.exports = __webpack_public_path__ + "static/nutrition_app_bar_layout-0fb8425783d7814e22141737096753a3.png";